export default "__VITE_ASSET__BnqvknbK__"